import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',

    overflow: 'hidden'
  },
  leftContent: {
    width: '100%'
  },
  filter: {
    display: 'flex',
    width: '100%'
  },
  datagrid: {
    marginRight: '15px',
    '& table tbody td': {
      cursor: 'pointer'
    }
  },
  searchBox: {
    width: '20vw',

    marginBottom: '20px',
    alignSelf: 'flex-end',

    justifyContent: 'flex-start',
    '& input': {
      width: '100%',
      height: '36px',
      fontSize: '14px',
      border: `1px solid #E0E0E0`,
      borderRadius: '5px',
      outline: 0,
      transition: 'all ease .4s',

      backgroundColor: '#fffff',
      padding: '0 15px',
      alignItems: 'center',
      '&:focus': {
        border: `1px solid #FFCD00 `,
        color: '#000'
      }
    },
    '& button': {
      cursor: 'pointer',

      border: 'none',
      color: '#fff',
      marginLeft: '5px',
      backgroundColor: 'rgb(0, 159, 227)',
      width: '50px',
      height: '35px',
      borderRadius: '5px'
    }
  },

  grid: {
    display: 'flex',
    flexDirection: 'column'
  },
  rightContent: {
    width: '50%'
  },
  buttons: {
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '& button': {
      cursor: 'pointer',
      border: 'none',

      color: '#fff',
      marginLeft: '5px',
      backgroundColor: 'rgb(0, 159, 227)',
      width: '60px',
      height: '35px',

      '&:hover': {
        backgroundColor: 'rgb(0, 159, 227)'
      }
    }
  },
  buttonsModal: {
    marginTop: '15px',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '& button': {
      cursor: 'pointer',
      border: 'none',

      marginLeft: '5px',

      width: '150px',
      height: '35px',
      borderRadius: '5px'
    }
  },

  add: {
    margin: '15px',
    '& small': {
      fontSize: '10px',
      color: '#808080'
    }
  },
  modalContent: {
    '& div': {
      margin: '15px',
      '& small': {
        fontSize: '10px',
        color: '#808080'
      },
      '& input, select': {
        width: '100%',
        height: '36px',
        fontSize: '14px',
        border: `1px solid #E0E0E0`,
        borderRadius: '5px',
        outline: 0,
        transition: 'all ease .4s',
        marginRight: '30px',

        backgroundColor: '#fffff',
        padding: '0 15px',
        alignItems: 'center',
        '&:focus': {
          border: `1px solid #FFCD00 `,
          color: '#000'
        },
        '&::placeholder': {
          color: '#E0E0E0'
        }
      },
      '& button': {}
    }
  },
  inputF: {
    '& div': {
      '& input, select': {
        width: '100%',
        height: '36px',
        fontSize: '14px',
        border: `1px solid #E0E0E0`,
        borderRadius: '5px',
        outline: 0,
        transition: 'all ease .4s',
        marginRight: '30px',
        marginBottom: '5px',
        backgroundColor: '#fffff',
        padding: '0 15px',
        alignItems: 'center',
        '&:focus': {
          border: `1px solid #FFCD00 `,
          color: '#000'
        },
        '&::placeholder': {
          color: '#E0E0E0'
        }
      }
    }
  },
  input: {
    '&:focus': {
      border: `1px solid #FFCD00 `,
      color: '#000 !important'
    }
  },
  compl: {
    width: '300px',
    // height: '20px',
    marginBottom: '10px'
  }
}));
